export default "__VITE_ASSET__ffb90123__"